import { createContext, useContext } from 'react';
import { Tours } from './config';

export interface TourContextValues {
  openTourMenu: boolean;
  tour: Tours;
  step: number;
  setOpenTourMenu: (openTourMenu: boolean) => void;
  show: (tour: Tours) => void;
  prev: () => void;
  next: () => void;
  jump: (step: number) => void;
  close: () => void;
}

const TourContext = createContext<TourContextValues>({} as any);
export default TourContext;

export function useTourContext() {
  return useContext(TourContext);
}
